import { cn } from '@/utils'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

interface ToolbarResetButtonProps {
  onReset: () => void
  /** Nothing to revert yet — the button reads as disabled and its tooltip says so. */
  disabled: boolean
  /** Tooltip copy while enabled, e.g. "Reset to original crop". */
  enabledTooltip: string
  /** Whether this button's tooltip is the one showing (the toolbar tracks a single hover key). */
  isHovered: boolean
  onHoverStart: () => void
  onHoverEnd: () => void
  /** The toolbar's portal root — see `TooltipContent`'s `container`. */
  tooltipContainer: HTMLElement | null
}

/** The red Reset button at the end of `CropToolbar`/`NodeEditToolbar`. */
export function ToolbarResetButton({
  onReset,
  disabled,
  enabledTooltip,
  isHovered,
  onHoverStart,
  onHoverEnd,
  tooltipContainer,
}: ToolbarResetButtonProps) {
  return (
    <Tooltip open={isHovered}>
      <TooltipTrigger asChild>
        <button
          onClick={onReset}
          disabled={disabled}
          onPointerEnter={onHoverStart}
          onPointerLeave={onHoverEnd}
          className={cn(
            'h-9 flex-shrink-0 rounded-lg border-none px-[14px] text-xs font-medium leading-normal text-white transition-colors',
            disabled
              ? 'cursor-not-allowed bg-red-600/40'
              : 'cursor-pointer bg-red-600 hover:bg-red-700'
          )}
        >
          Reset
        </button>
      </TooltipTrigger>
      <TooltipContent side="top" container={tooltipContainer}>
        {disabled ? 'No changes to reset' : enabledTooltip}
      </TooltipContent>
    </Tooltip>
  )
}
